import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { IMG } from "@/lib/site";
import Chapter from "@/components/cinema/Chapter";
import { Reveal, LineReveal } from "@/components/cinema/Reveal";

export default function IntroChapter() {
  return (
    <Chapter img={IMG.contentsPackout} overlay="left" testId="intro">
      <div className="grid md:grid-cols-12 gap-16 items-end">
        <div className="md:col-span-6">
          <Reveal y={16}><div className="eyebrow eyebrow-light mb-6">About BackHome</div></Reveal>
          <LineReveal
            className="display-chunky text-4xl md:text-6xl xl:text-7xl text-white leading-[0.92]"
            lines={["A trusted contents", "and restoration", "partner for Toronto."]}
          />
        </div>
        <div className="md:col-span-6 text-white/75 text-lg leading-relaxed space-y-6">
          <Reveal delay={0.3}>
            <p className="text-white font-semibold text-xl">
              BackHome Restoration Inc. provides emergency restoration support, contents assessment, inventory management, pack-out and pack-back services, storage solutions and professional moving services across Toronto and the GTA.
            </p>
          </Reveal>
          <Reveal delay={0.45}>
            <p>
              Our team works closely with homeowners, restoration contractors, property managers and insurance professionals to protect personal belongings, minimize disruption and simplify recovery after a loss.
            </p>
          </Reveal>
          <Reveal delay={0.6}>
            <Link to="/about" className="inline-flex items-center gap-2 text-[hsl(var(--gaza-blue-bright))] font-extrabold uppercase tracking-[0.18em] text-sm link-underline" data-testid="intro-about-link">
              More about us <ArrowRight className="w-4 h-4" />
            </Link>
          </Reveal>
        </div>
      </div>
    </Chapter>
  );
}
